export const FETCH_SELFCARE_FILES_REQUEST = 'FETCH_SELFCARE_FILES_REQUEST';
export const FETCH_SELFCARE_FILES_SUCCESS = "FETCH_SELFCARE_FILES_SUCCESS";
export const FETCH_SELFCARE_FILES_FAILURE = "FETCH_SELFCARE_FILES_FAILURE";

export const UPDATE_OPERATOR_REQUEST = "UPDATE_OPERATOR_REQUEST";
export const UPDATE_OPERATOR_SUCCESS = "UPDATE_OPERATOR_SUCCESS";
export const UPDATE_OPERATOR_FAILURE = "UPDATE_OPERATOR_FAILURE";